export class RequestCancelledException extends Error {
  constructor(message = 'Request was cancelled') {
    super(message);
    this.name = 'RequestCancelledException';
  }
}
